var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "triggers" } },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: _vm.$t("message.triggers") }],
            select: true,
          },
        },
        [
          _vm.checkPermission(_vm.PERMISSION_TYPES["trigers.create"].tr.name)
            ? _c(
                "a-button",
                {
                  staticClass: "actionButtonBreadcrumb",
                  on: { click: _vm.showModal },
                },
                [
                  _c("md-icon", [_vm._v("add")]),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("message.addTrigger")) +
                      "\n        "
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "bottom-end" },
                  expression: "{ followCursor: true, placement: 'bottom-end' }",
                },
              ],
              staticStyle: { margin: "0px 10px 3px" },
              attrs: {
                content: !_vm.isEnabledTriggers
                  ? _vm.$t("message.showTriggers")
                  : _vm.$t("message.hideTriggers"),
              },
            },
            [
              _c(
                "a-switch",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.isEnabledTriggers,
                    callback: function ($$v) {
                      _vm.isEnabledTriggers = $$v
                    },
                    expression: "isEnabledTriggers",
                  },
                },
                [
                  _c("a-icon", {
                    attrs: { slot: "checkedChildren", type: "check" },
                    slot: "checkedChildren",
                  }),
                  _vm._v(" "),
                  _c("a-icon", {
                    attrs: { slot: "unCheckedChildren", type: "close" },
                    slot: "unCheckedChildren",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("message.triggers")))]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "bottom-end" },
                  expression: "{ followCursor: true, placement: 'bottom-end' }",
                },
              ],
              staticStyle: { margin: "0px 10px 3px" },
              attrs: {
                content: !_vm.triggerSkipLoginForm
                  ? _vm.$t("message.triggerSkipLoginFormTrue")
                  : _vm.$t("message.triggerSkipLoginFormFalse"),
              },
            },
            [
              _c(
                "a-switch",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.triggerSkipLoginForm,
                    callback: function ($$v) {
                      _vm.triggerSkipLoginForm = $$v
                    },
                    expression: "triggerSkipLoginForm",
                  },
                },
                [
                  _c("a-icon", {
                    attrs: { slot: "checkedChildren", type: "check" },
                    slot: "checkedChildren",
                  }),
                  _vm._v(" "),
                  _c("a-icon", {
                    attrs: { slot: "unCheckedChildren", type: "close" },
                    slot: "unCheckedChildren",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("message.triggerSkipLoginForm"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.skeletonLoading
        ? _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "skeletons" },
                    [_c("b-skeleton-img")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "skeletons" },
                    [_c("b-skeleton-img")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "skeletons" },
                    [_c("b-skeleton-img")],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "b-container",
            { staticClass: "m-3", attrs: { fluid: "" } },
            [
              !!_vm.trigger && _vm.trigger.length <= 0
                ? _c(
                    "div",
                    {
                      staticClass: "card py-3",
                      staticStyle: {
                        "max-width": "700px",
                        width: "100%",
                        margin: "0 auto",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c("a-icon", {
                            staticStyle: {
                              "font-size": "30px",
                              color: "rgb(246 214 65)",
                            },
                            attrs: { type: "info-circle" },
                          }),
                          _vm._v(" "),
                          _c("h3", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(_vm.$t("message.noTrigger"))),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "trigger-recipe" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("message.toCreate"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _vm.checkPermission(
                              _vm.PERMISSION_TYPES["trigers.create"].tr.name
                            )
                              ? _c(
                                  "a-button",
                                  {
                                    staticClass: "actionButtonBreadcrumb mx-1",
                                    on: { click: _vm.showModal },
                                  },
                                  [
                                    _c("md-icon", [_vm._v("add")]),
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.$t("message.addTrigger")) +
                                        "\n                    "
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("message.clickTheButton"))),
                        ]),
                      ]),
                    ]
                  )
                : _c(
                    "draggable",
                    {
                      key: "trigger_" + _vm.renderCount,
                      staticClass: "row trigger-labels",
                      model: {
                        value: _vm.triggerOrdered,
                        callback: function ($$v) {
                          _vm.triggerOrdered = $$v
                        },
                        expression: "triggerOrdered",
                      },
                    },
                    _vm._l(_vm.triggerOrdered, function (item) {
                      return _c(
                        "b-col",
                        {
                          key: item._id,
                          staticClass:
                            "trigger-card m-3 d-flex flex-column justify-content-between",
                          attrs: { md: "4", id: item._id },
                        },
                        [
                          _c("div", { staticClass: "header" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  !!item.title
                                    ? item.title
                                    : _vm.$t("message.noTitle")
                                ) +
                                "\n                "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "bottom-end",
                                  },
                                  expression:
                                    "{ followCursor: true, placement: 'bottom-end' }",
                                },
                              ],
                              staticClass: "trigger-content",
                              attrs: {
                                content: (
                                  _vm.$_.get(item, "message.0.content", "") ||
                                  ""
                                ).replace(/\<\/?.*?\>/gi, "\n"),
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.clearHtml(item).length > 40
                                      ? _vm.clearHtml(item).substring(0, 38) +
                                          "..."
                                      : _vm.clearHtml(item)
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "content" },
                            _vm._l(item.conditions, function (c, i) {
                              return _c(
                                "div",
                                { key: i, staticClass: "content-item" },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("message." + c.condition))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm
                                          .$t("message." + c.operator)
                                          .toLowerCase()
                                      ) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "description" }, [
                                    _vm._v(_vm._s(c.value)),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex w-100 justify-content-center",
                            },
                            [
                              _vm.checkPermission(
                                _vm.PERMISSION_TYPES["trigers.update"].tr.name
                              )
                                ? _c(
                                    "a-button",
                                    {
                                      staticClass:
                                        "actionButton d-flex align-items-center mr-1",
                                      on: {
                                        click: function ($event) {
                                          return _vm.edit(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-right": "16px",
                                            display: "block",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("message.edit")))]
                                      ),
                                      _vm._v(" "),
                                      _c("ActionEdit"),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkPermission(
                                _vm.PERMISSION_TYPES["trigers.delete"].tr.name
                              )
                                ? _c(
                                    "a-button",
                                    {
                                      staticClass:
                                        "actionButton d-flex align-items-center",
                                      on: {
                                        click: function ($event) {
                                          return _vm.remove(item._id)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-right": "16px",
                                            display: "block",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.deleteField")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("ActionDelete"),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  staticClass:
                                    "actionButton d-flex align-items-center",
                                  staticStyle: { width: "inherit" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.playPreview(item)
                                    },
                                  },
                                },
                                [
                                  !!_vm.selectedTrigger &&
                                  _vm.selectedTrigger._id === item._id
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "mx-0 px-0",
                                          staticStyle: { display: "block" },
                                        },
                                        [
                                          _vm._v(
                                            "Pause\n                            "
                                          ),
                                          _c("a-icon", {
                                            staticStyle: {
                                              "margin-left": "5px",
                                            },
                                            attrs: { type: "pause-circle" },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass: "mx-0 px-0",
                                          staticStyle: { display: "block" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                            Play\n                            "
                                          ),
                                          _c("a-icon", {
                                            staticStyle: {
                                              "margin-left": "5px",
                                            },
                                            attrs: { type: "play-circle" },
                                          }),
                                        ],
                                        1
                                      ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom-end",
                                      },
                                      expression:
                                        "{ followCursor: true, placement: 'bottom-end' }",
                                    },
                                  ],
                                  staticClass: "separate-trigger-switch",
                                  attrs: {
                                    content: !item.enabled
                                      ? _vm.$t("message.showThisTrigger")
                                      : _vm.$t("message.hideThisTrigger"),
                                  },
                                },
                                [
                                  _c(
                                    "a-switch",
                                    {
                                      attrs: { size: "small" },
                                      on: {
                                        change: function ($event) {
                                          return _vm.updateTrigger(item)
                                        },
                                      },
                                      model: {
                                        value: item.enabled,
                                        callback: function ($$v) {
                                          _vm.$set(item, "enabled", $$v)
                                        },
                                        expression: "item.enabled",
                                      },
                                    },
                                    [
                                      _c("a-icon", {
                                        attrs: {
                                          slot: "checkedChildren",
                                          type: "check",
                                        },
                                        slot: "checkedChildren",
                                      }),
                                      _vm._v(" "),
                                      _c("a-icon", {
                                        attrs: {
                                          slot: "unCheckedChildren",
                                          type: "close",
                                        },
                                        slot: "unCheckedChildren",
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-left": "5px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.enabled
                                            ? _vm.$t("message.on")
                                            : _vm.$t("message.off")
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    1
                  ),
            ],
            1
          ),
      _vm._v(" "),
      _vm.checkPermission(_vm.PERMISSION_TYPES["trigers.create"].tr.name)
        ? _c(
            "div",
            {
              staticClass:
                "fab d-flex justify-content-center align-items-center",
              on: { click: _vm.showModalWithoutEdit },
            },
            [_c("md-icon", {}, [_vm._v("add")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "trigger-form",
                title: _vm.editMode
                  ? _vm.$t("message.updateTrigger")
                  : _vm.$t("message.addTrigger"),
                "show-footer": false,
                size: "lg",
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _c(
                "div",
                { attrs: { id: "modal-inner" } },
                [
                  _c(
                    "b-form",
                    {
                      staticClass: "d-flex flex-column justify-content-center",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.handleSave.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: _vm.$t("message.title") } },
                                [
                                  _c("b-form-input", {
                                    model: {
                                      value: _vm.form.title,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "title", $$v)
                                      },
                                      expression: "form.title",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("b-checkbox-group", {
                                staticClass: "d-flex flex-column my-3",
                                attrs: { options: _vm.options },
                                model: {
                                  value: _vm.form.options,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "options", $$v)
                                  },
                                  expression: "form.options",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column my-3" },
                                [
                                  _c(
                                    "b-checkbox",
                                    {
                                      attrs: {
                                        type: "checkbox",
                                        id: "headerCheckbox",
                                      },
                                      model: {
                                        value: _vm.form.showHeaderImage,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "showHeaderImage",
                                            $$v
                                          )
                                        },
                                        expression: "form.showHeaderImage",
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "headerCheckbox" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.showHeaderImage")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-checkbox",
                                    {
                                      attrs: {
                                        type: "checkbox",
                                        id: "popupCheckbox",
                                      },
                                      model: {
                                        value: _vm.form.popupTireggers,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "popupTireggers",
                                            $$v
                                          )
                                        },
                                        expression: "form.popupTireggers",
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "popupCheckbox" } },
                                        [_vm._v("Ekranın Ortasında Göster")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              false
                                ? _c(
                                    "div",
                                    { staticClass: "row" },
                                    [
                                      _c("a-input", {
                                        staticClass: "col mx-3 py-1 px-2",
                                        attrs: {
                                          placeholder:
                                            _vm.$t("message.yesPlease"),
                                          type: "text",
                                        },
                                        model: {
                                          value: _vm.form.firstAnswer,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "firstAnswer",
                                              $$v
                                            )
                                          },
                                          expression: "form.firstAnswer",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("a-input", {
                                        staticClass: "col mx-3 py-1 px-2",
                                        attrs: {
                                          placeholder:
                                            _vm.$t("message.noThanks"),
                                          type: "text",
                                        },
                                        model: {
                                          value: _vm.form.secondAnswer,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "secondAnswer",
                                              $$v
                                            )
                                          },
                                          expression: "form.secondAnswer",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.form.options.includes("ask")
                                ? _c(
                                    "div",
                                    { staticClass: "row d-flex" },
                                    [
                                      _c("MultiContent", {
                                        staticClass: "col mx-3 py-1 px-2 w-25",
                                        attrs: { hideTextCustomization: true },
                                        model: {
                                          value: _vm.multiFirstAnswerComp,
                                          callback: function ($$v) {
                                            _vm.multiFirstAnswerComp = $$v
                                          },
                                          expression: "multiFirstAnswerComp",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("MultiContent", {
                                        staticClass: "col mx-3 py-1 px-2 w-25",
                                        attrs: { hideTextCustomization: true },
                                        model: {
                                          value: _vm.multiSecondAnswerComp,
                                          callback: function ($$v) {
                                            _vm.multiSecondAnswerComp = $$v
                                          },
                                          expression: "multiSecondAnswerComp",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("MultiContent", {
                                ref: "MultiContent",
                                model: {
                                  value: _vm.multiContentComp,
                                  callback: function ($$v) {
                                    _vm.multiContentComp = $$v
                                  },
                                  expression: "multiContentComp",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "message.messageDurationPerRow"
                                    ),
                                  },
                                },
                                [
                                  _c("a-slider", {
                                    attrs: { max: 60, min: 0, step: 1 },
                                    model: {
                                      value: _vm.form.messageDuration,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "messageDuration",
                                          $$v
                                        )
                                      },
                                      expression: "form.messageDuration",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("h4", { staticClass: "my-2" }, [
                        _vm._v(_vm._s(_vm.$t("message.conditions"))),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.form.conditions, function (c, i) {
                        return _c(
                          "b-row",
                          { key: i, staticClass: "mb-3" },
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c(
                                  "b-form-select",
                                  {
                                    model: {
                                      value: c.condition,
                                      callback: function ($$v) {
                                        _vm.$set(c, "condition", $$v)
                                      },
                                      expression: "c.condition",
                                    },
                                  },
                                  _vm._l(
                                    Object.keys(_vm.conditions || {}),
                                    function (condKey) {
                                      return _c(
                                        "option",
                                        { domProps: { value: condKey } },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$t("message." + condKey)
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c(
                                  "b-form-select",
                                  {
                                    model: {
                                      value: c.operator,
                                      callback: function ($$v) {
                                        _vm.$set(c, "operator", $$v)
                                      },
                                      expression: "c.operator",
                                    },
                                  },
                                  _vm._l(
                                    _vm.operators[
                                      _vm.conditions[c.condition].operator
                                    ],
                                    function (operator) {
                                      return _c(
                                        "option",
                                        { domProps: { value: operator } },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$t("message." + operator)
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _vm.$_.isArray(
                                  _vm.conditions[c.condition].options
                                )
                                  ? _c(
                                      "b-form-select",
                                      {
                                        model: {
                                          value: c.value,
                                          callback: function ($$v) {
                                            _vm.$set(c, "value", $$v)
                                          },
                                          expression: "c.value",
                                        },
                                      },
                                      _vm._l(
                                        _vm.conditions[c.condition].options,
                                        function (option) {
                                          return _c(
                                            "option",
                                            {
                                              domProps: {
                                                value: _vm.$_.isObject(option)
                                                  ? option.value
                                                  : option,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$_.isObject(option)
                                                      ? option.label
                                                      : option
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : !!_vm.conditions[c.condition].options
                                  ? _c(
                                      "b-form-select",
                                      {
                                        model: {
                                          value: c.value,
                                          callback: function ($$v) {
                                            _vm.$set(c, "value", $$v)
                                          },
                                          expression: "c.value",
                                        },
                                      },
                                      _vm._l(
                                        _vm.getState(
                                          _vm.conditions[c.condition].options
                                        ),
                                        function (option) {
                                          return _c(
                                            "option",
                                            {
                                              domProps: { value: option.value },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(option.label) +
                                                  "\n                            "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _c("b-form-input", {
                                      model: {
                                        value: c.value,
                                        callback: function ($$v) {
                                          _vm.$set(c, "value", $$v)
                                        },
                                        expression: "c.value",
                                      },
                                    }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-col", { attrs: { md: "1" } }, [
                              _c(
                                "div",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delCondition(i)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "md-icon",
                                    { staticClass: "text-danger" },
                                    [_vm._v("delete")]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      !_vm.form.conditions.length
                        ? _c(
                            "p",
                            {
                              staticClass: "text-center m-1 p-2",
                              staticStyle: { background: "yellow" },
                              attrs: { id: "trigger-no-condition-text" },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.noCondition")) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "mb-5 mt-2",
                          staticStyle: { width: "50px" },
                          attrs: { variant: "primary", size: "sm" },
                          on: { click: _vm.addCondition },
                        },
                        [
                          _c("md-icon", { staticClass: "text-white" }, [
                            _vm._v("add"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12", id: "buttons" } },
                            [
                              _c(
                                "b-button",
                                { on: { click: _vm.hideModal } },
                                [
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("message.cancel")) +
                                        "\n                            "
                                    ),
                                  ],
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    disabled: _vm.loading,
                                    type: "submit",
                                    variant: "primary",
                                  },
                                },
                                [
                                  !_vm.loading
                                    ? [
                                        !_vm.editMode
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t("message.save")
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t("message.update")
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]),
                                      ]
                                    : [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "spinner", spin: "" },
                                        }),
                                      ],
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isAdmin ? _c("ChatBar", { attrs: { visible: false } }) : _vm._e(),
      _vm._v(" "),
      !!_vm.selectedTrigger
        ? _c("TriggerPreview", {
            attrs: { trigger: _vm.selectedTrigger },
            on: {
              "trigger-end": function ($event) {
                _vm.selectedTrigger = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }